import { BaseEntity } from "@app/models/rest/base-entity";
import { Team } from "@app/models/rest/team";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("planners")
export class Planner extends BaseEntity {
  displayName: string;
  teamList: Team[];
}

@HateoasProjection(Planner, "detail")
export class PlannerDetail extends BaseEntity {
  displayName: string;

  @ProjectionRel(Team)
  teamList: Team[];
}
